'use client';
import React, { useState } from 'react';

const TextArea = ({
  placeholder = '',
  value = '',
  onChange,
  disabled = false,
  className = '',
  rows = 4,
  size = 'md',
  variant = 'default',
  fullWidth = true,
  ...props
}) => {
  const [focused, setFocused] = useState(false);

  const variants = {
    default: 'border-primary bg-white text-primary focus:border-secondary focus:ring-secondary',
    footer: 'border-white bg-transparent text-white placeholder-white focus:border-accent focus:ring-accent'
  };

  const sizes = {
    sm: 'px-4 py-2 text-sm sm:px-5 sm:py-2.5 sm:text-base',
    md: 'px-6 py-3 text-base sm:px-8 sm:py-4 sm:text-lg',
    lg: 'px-8 py-4 text-lg sm:px-10 sm:py-5 sm:text-xl'
  };

  return (
    <textarea data-component-id="src/components/ui/TextArea.jsx:30:4" data-component-path="src/components/ui/TextArea.jsx" data-component-line="30" data-component-file="TextArea.jsx" data-component-name="textarea" data-component-content="%7B%22elementName%22%3A%22textarea%22%2C%22value%22%3A%22%5Bvar%3Avalue%5D%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled}
      rows={rows}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      className={`
        rounded-lg sm:rounded-xl md:rounded-2xl
        border
        transition-all
        duration-200
        ease-in-out
        focus:outline-none
        focus:ring-2
        focus:ring-opacity-50
        font-space-grotesk
        resize-vertical
        ${variants?.[variant]}
        ${sizes?.[size]}
        ${fullWidth ? 'w-full' : ''}
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        ${focused ? 'scale-[1.02]' : ''}
        placeholder-textMuted
        ${className}
      `?.trim()?.replace(/\s+/g, ' ')}
      {...props}
    />
  );
};

export default TextArea;